export const documentAnnotationsConstants = {
    SET_SHARED_ANNOTATIONS_FOR_DOCUMENTID: 'SET_SHARED_ANNOTATIONS_FOR_DOCUMENTID',
    CLEAR_SHARED_ANNOTATIONS_FOR_DOCUMENTID: 'CLEAR_SHARED_ANNOTATIONS_FOR_DOCUMENTID',
}
